import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "../../components/button/Button";
import { Input } from "../../components/input/Input";
import { InputGroup } from "../../components/inputGroup/InputGroup";
import { useDispatch, useSelector } from "react-redux";
import {
  postLoginSuccess,
  postUserOtp,
  postLoginId,
  postLoginFailure,
  postUserData,
  postClientOtpData,
} from "../../redux/slices/loginSlice";
import Base64 from "../../utils/base64";
import Loader from "../../components/styled-components/loader/loader";

import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";
import axios from "axios";
import ROUTES from "../../config/routes";

const OtpValidate = () => {
  const userId = useSelector((state) => state.rootReducer.loginUser.userId);
  const userData = useSelector((state) => state.rootReducer.loginUser.UserData);
  const clientOTPData = useSelector(
    (state) => state.rootReducer.loginUser.clientOtpData
  );

  const dispatch = useDispatch();
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const location = useLocation();
  console.log("location in otp", location);
  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };
  const getClientList = async () => {
    // setLoading(true)
    let responseData = await DEATH_API.fetchClientList();
    // console.log("responseData", responseData.data)
    const newData =
      responseData.data &&
      responseData.data[0] &&
      responseData.data[0].users &&
      responseData.data[0].users;
    // console.log("newData",newData)
    newData && newData.map((item, index) => (item["Status"] = false));
    console.log("newData", newData);

    localStorage.setItem("delegateUsers", JSON.stringify(newData));
    setLoading(false);
    swal("Success", "Login Success", "success");
    console.log("here in otp validate");
    if (location.state && location.state.from && location.state.from.pathname) {
      history.push({
        pathname: location.state.from.pathname,
        state: { from: location.state.from },
        PathExact: location.PathExact,
      });
      console.log("here in api");
    } else {
      history.push("/delgateAccess");
    }
  };

  useEffect(() => {
    if (
      !userId ||
      userId === null ||
      userId === "" ||
      Object.keys(userData).length === 0
    ) {
      history.push("/login");
    }
  }, []);

  const handleClientOtpSuccess = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/verifyClientOTP`,
        {
          userName: clientOTPData.username,
          password: clientOTPData.password,
          otp: userOtp,
        },
        config
      );

      console.log("response client otp verify", res.data);
      let outputObj = {};
      if (res.status === 200 && res.data.access_token) {
        console.log("resonse.data login", res.data);
        dispatch(postLoginSuccess(res.data));

        if (res.data.user.roles) {
          const loginRole = res.data.user.roles;
          console.log("loginRole", loginRole);
          if (loginRole.test111) {
            localStorage.setItem(
              "role",
              JSON.stringify(loginRole.test111.name)
            );
          } else if (loginRole.protrustee) {
            localStorage.setItem(
              "role",
              JSON.stringify(loginRole.protrustee.name)
            );
          } else if (loginRole.superAdmin) {
            localStorage.setItem(
              "role",
              JSON.stringify(loginRole.superAdmin.name)
            );
          } else {
            let recursive = (obj, name) => {
              for (let key in obj) {
                if (typeof obj[key] == "object") {
                  recursive(obj[key], name + "_" + key);
                } else {
                  outputObj[key] = obj[key];
                }
              }
            };
            recursive(loginRole, "loginRole");
            console.log("outputObj", outputObj);
            localStorage.setItem("role", JSON.stringify(outputObj.name));
          }
        }
        localStorage.setItem("userData", JSON.stringify(res.data.user));
        localStorage.setItem("User", res.data.user.name);
        if (res.data.user.image !== null) {
          localStorage.setItem("profile", res.data.user.image);
        }
        localStorage.setItem("userName", res.data.user.userName);
        dispatch(postLoginId(res.data.id));
        localStorage.setItem("userLoginToken", res.data.access_token);

        console.log("es.data.access_token", res.data.access_token);

        if (res.data.user.permissions) {
          let permissions = res.data.user.permissions;
          const namesArray = Object.values(permissions).map(
            (permission) => permission.name
          );
          console.log("namesArray", namesArray);
          localStorage.setItem("permissionState", JSON.stringify(namesArray));

          // dispatch(postPermissionsSuccess(namesArray));
        }

        if (res.data.access_token) {
          setLoading(true);
          console.log("here in getting delegateusers");

          let newData = [];
          // if (outputObj.name !== "inactiveClient") {
          //   getClientList();
          //   let responseData = await DEATH_API.fetchClientList();
          //   console.log("newData 11", responseData);

          //   if (
          //     responseData.data &&
          //     responseData.data[0] &&
          //     responseData.data[0].users
          //   ) {
          //     newData = responseData.data[0].users;
          //     newData.map((item, index) => (item["Status"] = false));
          //   }

          //   console.log("newData", newData);
          // }
          // localStorage.setItem("delegateUsers", JSON.stringify(newData));
          setLoading(false);
          // swal("Success", "Login Success", "success");

          if (
            location.state &&
            location.state.from &&
            location.state.from.pathname
          ) {
            history.push({
              pathname: location.state.from.pathname,
              state: { from: location.state.from },
              PathExact: location.PathExact,
            });
            console.log("here in api");
          } else {
            if (newData.length > 0) {
              history.push("/dashboard");
            } else {
              if (outputObj.name === "inactiveClient") {
                history.push("/payment");
              } else {
                history.push("/dashboard");
              }
            }
          }

          dispatch(postClientOtpData({}));
        }

        // history.push("/dashboard");
      } else {
        // history.push("/otpvalidation");
        // swal("ERROR!", "While Login....")
      }
    } catch (error) {
      setLoading(false);
      swal("Oops!", error.response.data.message, "error");
      console.log("error in otp", error.response);
    }
  };

  const handleOtpSuccess = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/verifyOTP`,
        { id: userId, otp: userOtp },
        config
      );
      // setLoading(false)

      console.log("response otp verify", res.data);

      if (res.status === 200 && res.data.access_token) {
        // swal('Success', "Login Success", 'success')
        console.log("res inside if enter ", res.data);
        dispatch(postLoginSuccess(res.data));
        console.log("new data otp", res.data);

        console.log("res.data in opt", res.data);
        dispatch(postUserOtp(userOtp));
        localStorage.setItem("userData", JSON.stringify(res.data.user));
        localStorage.setItem("User", res.data.user.name);
        if (res.data.user.image !== null) {
          localStorage.setItem("profile", res.data.user.image);
        }

        localStorage.setItem("userLoginToken", res.data.access_token);
        if (res.data.user.roles) {
          if (res.data.user.roles && res.data.user.roles.protrustee) {
            localStorage.setItem(
              "role",
              JSON.stringify(res.data.user.roles.protrustee.name)
            );
          } else {
            let outputObj = {};
            let recursive = (obj, name) => {
              for (let key in obj) {
                if (typeof obj[key] == "object") {
                  recursive(obj[key], name + "_" + key);
                } else {
                  outputObj[key] = obj[key];
                }
              }
            };
            recursive(res.data.user.roles, "loginRole");
            console.log("outputObj", outputObj);
            localStorage.setItem("role", JSON.stringify(outputObj.name));
          }
        } else if (res.data.trustee_Role && res.data.trustee_Role.roleName) {
          console.log("res after if", res.data.trustee_Role.roleName);
          localStorage.setItem(
            "role",
            JSON.stringify(res.data.trustee_Role.roleName)
          );
        }
        if (res.data.user.permissions) {
          let permissions = res.data.user.permissions;
          const namesArray = Object.values(permissions).map(
            (permission) => permission.name
          );
          console.log("namesArray", namesArray);
          localStorage.setItem("permissionState", JSON.stringify(namesArray));

          // dispatch(postPermissionsSuccess(namesArray));
        }
        dispatch(postUserData({}));
        dispatch(postLoginId(""));

        getClientList();

        // setLoading(false)

        // history.push("/delgateAccess");
      }
    } catch (error) {
      setLoading(false);
      swal("Oops!", error.response.data.message, "error");
      console.log(error);
    }
  };

  const reSendOTP = async () => {
    if (clientOTPData.hasOwnProperty("username")) {
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signinClient`,
          clientOTPData,
          config
        );
        console.log("response otp resend", res);
        if (res.data.status === 200) {
          console.log("responsse of login", res.data.id);
          swal("Success", res.data.message, "success");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signin`,
          userData,
          config
        );
        console.log("response otp resend", res);
        if (res.data.status === 200) {
          console.log("responsse of login", res.data.id);
          swal("Success", res.data.message, "success");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const handleKeyPress = async (event) => {
    if (event.key === "Enter") {
      if (clientOTPData.hasOwnProperty("username")) {
        handleClientOtpSuccess();
      } else {
        handleOtpSuccess();
      }
    }
  };
  const history = useHistory();
  const [userOtp, setuserOtp] = useState("");
  const [loading, setLoading] = useState(false);

  console.log("useruser", JSON.stringify(userId));
  return (
    <div>
      <div style={{ marginTop: "20px" }}>
        {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
        <div className="login-card border">
          <h2 className="login-heading">OTP Verification Form</h2>
          <div>
            <InputGroup>
              <label>Enter OTP</label>
              <Input
                onChange={(e) => {
                  const result = e.target.value.replace(/\D/g, "");
                  setuserOtp(result);
                }}
                id="otp"
                type="text"
                pattern="[0-9.]+"
                onKeyPress={handleKeyPress}
                value={userOtp && userOtp}
                // pattern="[0-9]+"
                // pattern="\d*"
                // maxlength="4"
                maxLength={6}
                placeholder="***OTP***"
                name="otp"></Input>
            </InputGroup>

            <Button
              style={{ background: "#2A3DA3" }}
              onClick={() => {
                if (clientOTPData.hasOwnProperty("username")) {
                  handleClientOtpSuccess();
                } else {
                  handleOtpSuccess();
                }
              }}>
              Verify
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "2rem",
            }}>
            <Button
              style={{ background: "#2A3DA3" }}
              onClick={() => {
                reSendOTP();
              }}>
              Resend OTP
            </Button>
          </div>
          <div className="problemText" style={{ marginTop: "1rem" }}>
            Not receiving OTP?{" "}
          </div>
          <div className="problemText">
            Ensure (888) 375-2040 is unblocked in your phone!{" "}
          </div>
          <div className="problemText">Still Not receiving? </div>
          <div className="problemText">
            Contact us at{" "}
            <span style={{ color: "rgb(57, 181, 74" }}>
              <a
                style={{ color: "#2a3da3" }}
                href="mailto:support@assetplanet.com">
                support@assetplanet.com
              </a>
            </span>
          </div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
};

export default OtpValidate;
